






import { mapGetters } from 'vuex'
import { CLASSIFIED_VIEW_NS } from '~/store/modules/shared/classifieds/view/state'
import { mapDeps } from '~/plugins/dependency-container/utils'
import DealerSiteService from '~/services/dealers/site/DealerSiteService'
import { defineComponent } from '~/utils/nuxt3-migration'

export default defineComponent({
  computed: {
    ...mapGetters(CLASSIFIED_VIEW_NS, ['shouldDisplayAds']),
    ...mapDeps({
      dealerSiteService: DealerSiteService
    }),
    isShown() {
      const isDealerSiteRoute = this.dealerSiteService.routeIsOfDealerSite()
      return this.shouldDisplayAds && !isDealerSiteRoute
    }
  }
})
